export type LocalAiMetric = 'modelLoad' | 'stt' | 'semantic' | 'llm' | 'prepare' | 'endToEnd';

const measurements = new Map<LocalAiMetric, number[]>();

export function recordLocalAiDuration(metric: LocalAiMetric, durationMs: number): void {
  const values = measurements.get(metric) ?? [];
  values.push(Math.max(0, durationMs));
  if (values.length > 200) values.shift();
  measurements.set(metric, values);
}

export function localAiPercentiles(metric: LocalAiMetric): { p50?: number; p95?: number } {
  const values = [...(measurements.get(metric) ?? [])].sort((left, right) => left - right);
  if (values.length === 0) return {};
  const at = (quantile: number) => values[Math.min(values.length - 1, Math.floor(values.length * quantile))];
  const p50 = at(0.5);
  const p95 = at(0.95);
  return {
    ...(p50 === undefined ? {} : { p50 }),
    ...(p95 === undefined ? {} : { p95 }),
  };
}
